




































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class InputEmail extends Vue {
  @Prop({ required: true })
  readonly step: number

  email: string = ''

  async submit() {
    const validated = await this.validateForm()

    if (!validated) {
      return
    }
    this.$emit('input-email', this.email)
  }

  private async validateForm(): Promise<boolean> {
    if (this.email.length === 0) {
      return false
    }

    this.$validator.validateAll()

    return this.$validator.validateAll()
  }
}
